import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencilSquareIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 19.2 19.3",
	style: { enableBackground: "new 0 0 19.2 19.3" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.pencil-square-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "pencil-square-icon-st0",
			d: "M9.2,13h-3v-3l9-9l3,3L9.2,13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "pencil-square-icon-st0",
			d: "M13,3.3l3,3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "pencil-square-icon-st0",
			d: "M17.4,9.3v8.3c0,0.2-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2h-15c-0.2,0-0.4-0.1-0.5-0.2S1,17.8,1,17.6v-15 C1,2.3,1,2.1,1.2,2c0.2-0.1,0.3-0.2,0.5-0.2h8.2"
		})
	] }) }) })]
});
export default SvgPencilSquareIcon;
